import { PropsWithChildren } from "react"
import SubdirectoryArrowLeftIcon from '@mui/icons-material/SubdirectoryArrowLeft';

export interface MenuElementProps extends PropsWithChildren {
    subItem?: boolean
}

export const MenuElement: React.FC<MenuElementProps> = (props) => {
    return (
        <div className="flex flex-row w-full gap-1 py-2 px-3 hover:bg-gray-100 text-md lg:text-sm lg:w-[200px] rounded-xl transform transition-all duration-500">
            {props.subItem && 
            <div className="text-primary rotate-90"><SubdirectoryArrowLeftIcon style={{
                height: "16px",
                width: "auto"
            }}/></div>
            }
            {props.children}
        </div>
    )
}